// A part as ViewSongPart marks it up. Continuous view shows every song of a service at once, so a part
// is looked for inside its own song when that is known
export const findPartNode = (partId, songId = null) => {
  const part = `[data-part-id="${CSS.escape(partId)}"]`;

  return document.querySelector(songId ? `[data-song-id="${CSS.escape(songId)}"]${part}` : part);
};

// Clear of the bar, with room for the highlight's ring to spread above the chip
const GAP_UNDER_BAR = 16;

// The service bar's height once pinned, as the jump itself will pin it: unpinned, it hides its compact
// controls and comes out shorter. Pinned and unpinned in one go, so nothing is painted in between
const pinnedBarHeight = () => {
  const bar = document.querySelector('.view__service-bar');

  if (!bar) return 0;
  if (bar.classList.contains('pinned')) return bar.offsetHeight;

  bar.classList.add('pinned');
  const height = bar.offsetHeight;
  bar.classList.remove('pinned');

  return height;
};

// Brings a part's top to just under the sticky service bar, which would otherwise cover it
export const scrollToPartNode = (node) => {
  const top = node.getBoundingClientRect().top + window.pageYOffset - pinnedBarHeight() - GAP_UNDER_BAR;

  window.scrollTo({ top, behavior: 'smooth' });
};

// Rings the part's chip a few times, so whoever was brought to it can see where they landed
export const highlightPartNode = (node) => {
  const chip = node.querySelector('.music-tag');

  if (!chip) return;

  chip.classList.add('jump-highlight');
  chip.addEventListener('animationend', () => chip.classList.remove('jump-highlight'), { once: true });
};
